var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('nav-bar'),_c('v-main',{staticClass:"ma-5"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }